export default __webpack_public_path__ + "static/media/Custom-HUD-3D Widget.12455cdc.jpg";